'use client';

import { toast } from 'sonner';

import { DynamicIcon } from '@natu/ui/DynamicIcon';

export const ArticleAuthorCopyToClipboardButton = () => {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(window.location.toString());
    toast('URL saved to clipboard');
  };

  return (
    <button
      aria-label="Copy to clipboard"
      type="button"
      onClick={handleCopyToClipboard}
      className="shadow-xs flex size-9 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white"
    >
      <DynamicIcon icon="link" className="h-auto w-4 text-gray-400" />
    </button>
  );
};
